import { Field, useFormikContext } from 'formik';
import MuiValidTextField from 'src/components/util/MuiValidTextField';
import Section from 'src/components/util/Section';
import Subheader from 'src/components/util/Subheader';
import Address from '../util/Address';

export default function MotorVehicleInfo() {
  const form = useFormikContext();

  return (
    <Section title="Motor Vehicle Information">
      <Field
        InputLabelProps={{ shrink: true }}
        component={MuiValidTextField}
        label="VIN (Vehicle Identification Number)"
        onChange={(e) => {
          form.setFieldValue('info.vin', e.target.value);
        }}
        name="info.vin"
        type="number"
      />
      <Subheader>Location or Address of Subject Property</Subheader>
      <Address
        fieldNames={{
          street: 'info.address.street',
          city: 'info.address.city',
          state: 'info.address.state',
          zip: 'info.address.zip',
        }}
      />
    </Section>
  );
}
